import { getSession } from 'lib/auth'

export const isUserHaveRole = (roleName) => {
  const { user } = getSession()
  const roles = user?.designation?.roles || []
  return roles.some((role) => role.name === roleName) || false
}
